import React from 'react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'; // default file icon
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; // for PDF files
import MicIcon from '@mui/icons-material/Mic'; // for audio files
import TheatersIcon from '@mui/icons-material/Theaters'; // for video files
import DescriptionIcon from '@mui/icons-material/Description'; // for documents
import { Box, SxProps, Typography } from '@mui/material';
import { MediaType } from './types';

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  justifyContent: 'space-between'
};

const fileNameStyle: SxProps = {
  maxWidth: '300px',
  overflow: 'hidden'
};

type Props = {
  fileName: string | undefined;
  mediaType: MediaType;
};

const MediaPreview: React.FC<Props> = ({ fileName, mediaType }) => {
  const getFileIcon = () => {
    switch (mediaType) {
      case MediaType.PDF:
        return <PictureAsPdfIcon />;
      case MediaType.AUDIO:
        return <MicIcon />;
      case MediaType.VIDEO:
        return <TheatersIcon />;
      case MediaType.DOCUMENT:
        return <DescriptionIcon />;
      case MediaType.OTHER:
        return <InsertDriveFileIcon />;
    }
  };

  return (
    <Box sx={container}>
      {getFileIcon()}
      <Typography sx={fileNameStyle}>{fileName}</Typography>
    </Box>
  );
};

export { MediaPreview };
